import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["checked", "className", "description", "descriptionInfoText", "descriptionInfoBadgeAriaLabel", "disabled", "label", "labelInfoText", "labelInfoBadgeAriaLabel", "onCheckedChange", "value"];
import { jsxs, jsx } from 'react/jsx-runtime';
import { Checkmark, Minus } from '@box/blueprint-web-assets/icons/Fill';
import { IconIconOnDark, Size3 } from '@box/blueprint-web-assets/tokens/tokens';
import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { TextWithInfoBadge } from '../util-components/text-with-info-badge/text-with-info-badge.js';
import { useUniqueId } from '../utils/useUniqueId.js';
import styles from './checkbox.module.js';
/** Checkbox.Item needs to be wrapped with TooltipProvider -
    or ideally you should have your App wrapped with it. */

var CheckboxItem = /*#__PURE__*/forwardRef(function (props, ref) {
  var checked = props.checked,
      className = props.className,
      description = props.description,
      descriptionInfoText = props.descriptionInfoText,
      descriptionInfoBadgeAriaLabel = props.descriptionInfoBadgeAriaLabel,
      disabled = props.disabled,
      label = props.label,
      labelInfoText = props.labelInfoText,
      labelInfoBadgeAriaLabel = props.labelInfoBadgeAriaLabel,
      onCheckedChange = props.onCheckedChange,
      value = props.value,
      rest = _objectWithoutProperties(props, _excluded);

  var descriptionId = useUniqueId('description-', !!description);
  return jsxs("div", {
    className: clsx([styles.option], _defineProperty({}, styles.disabled, disabled), className),
    children: [jsxs("label", {
      className: styles.label,
      children: [jsx(RadixCheckbox.Root, _objectSpread(_objectSpread({}, rest), {}, {
        ref: ref,
        "aria-describedby": descriptionId,
        checked: checked,
        className: styles.checkbox,
        disabled: disabled,
        onCheckedChange: onCheckedChange,
        value: value,
        children: jsxs(RadixCheckbox.Indicator, {
          className: styles.indicator,
          forceMount: true,
          children: [checked === true && jsx(Checkmark, {
            color: IconIconOnDark,
            height: Size3,
            role: "presentation",
            width: Size3
          }), checked === 'indeterminate' && jsx(Minus, {
            color: IconIconOnDark,
            height: Size3,
            role: "presentation",
            width: Size3
          })]
        })
      })), jsx(TextWithInfoBadge, {
        infoBadgeAriaLabel: labelInfoBadgeAriaLabel,
        infoText: labelInfoText,
        variant: disabled ? 'muted' : 'default',
        children: label
      })]
    }), jsx("div", {
      className: styles.description,
      children: description ? jsx(TextWithInfoBadge, {
        id: descriptionId,
        infoBadgeAriaLabel: descriptionInfoBadgeAriaLabel,
        infoText: descriptionInfoText,
        variant: "muted",
        children: description
      }) : null
    })]
  });
});
export { CheckboxItem };